export enum WorldpayTestHooks {
  Form = 'credit-card-form',
  WorldpayIframe = 'worldpay-iframe',
}
